export default __webpack_public_path__ + "static/char-v-13-5f53bab636b33b27f554d49e4d89fa4f.mp4";